import Navbar from "./Navbar";
import Footer from "./Footer";
import "./container.css";
import "./GrievanceRedressal.css";

const companyName = () => import.meta.env.VITE_COMPANY_NBFC || "Naman Finlease Pvt. Ltd.";
const registeredAddress = () =>
  import.meta.env.VITE_COMPANY_ADDRESS || "H-144, Sector 63, Noida, Uttar Pradesh, India - 201309";

const GrievanceRedressal = () => {
  return (
    <div className="grievance-page">
      <Navbar />

      <div className="grievance-hero">
        <div className="container-8xl">
          <h1 className="grievance-title">Grievance Redressal Policy</h1>
          <p className="grievance-subtitle">
            {companyName()} — Registered Address: {registeredAddress()}
          </p>
          <p className="grievance-subtitle">
            (Approved and adopted by the Board of Directors)
          </p>
        </div>
      </div>

      <div className="container-8xl">
        <div className="grievance-card">
          <div className="grievance-section">
            <h2 className="grievance-section-title">1. Preface</h2>
            <p>
              {companyName()} (the "Company"), operating under the brand{" "}
              {import.meta.env.VITE_COMPANY_NAME}, is a Non-Banking Financial Company registered
              with the Reserve Bank of India, having its registered office at {registeredAddress()}
              . This Grievance Redressal Policy is framed in terms of the applicable Reserve Bank
              of India directions and guidelines relating to Non-Banking Financial Companies, as
              amended from time to time ("Directions"). It is essential that grievances of
              customers are given due consideration and quick action is taken to resolve the same.
              To provide efficient and enhanced services to customers and resolution of their
              grievances, the Company has adopted this Grievance Redressal Policy providing for an
              effective Grievance Redressal Mechanism.
            </p>
            <p>
              This policy outlines the resolution timeline and the escalation matrix for the
              smooth disposal of complaints and lays down the responsibility of the Company to
              ensure that all grievances are resolved within 30 days from the date of raising the
              complaint. If the grievance is not resolved within 30 days, or the customer remains
              unsatisfied with the resolution, the customer may approach the Reserve Bank of India
              for further resolution.
            </p>
            <p>
              This policy also lays down the responsibility of the Company to display the
              Grievance Redressal Policy on the Company's website and make it available at all
              branches / points of customer interface.
            </p>
          </div>

          <div className="grievance-section">
            <h2 className="grievance-section-title">2. Objective</h2>
            <p>
              This policy shall apply to complaints arising out of actions of the Company's
              agents, recovery agents, digital lending partners, and other service providers
              (where applicable), who are bound by the commitments provided below:
            </p>
            <ul>
              <li>Offering efficient channels to route customer queries.</li>
              <li>Complaints raised by customers shall be dealt with courtesy and resolved in a timely manner.</li>
              <li>
                Customers shall be informed of avenues to escalate their complaints within the
                organization, and of their rights in cases where their complaints are not resolved
                in a timely manner or when they are not satisfied with the resolution.
              </li>
            </ul>
          </div>

          <div className="grievance-section">
            <h2 className="grievance-section-title">3. Grievance Redressal Mechanism</h2>
            <p>
              Any customer having a grievance / complaint / feedback with respect to the service
              offered by the Company may write to the Company by following the Escalation Matrix
              below.
            </p>
            <p style={{ fontWeight: 600, color: "#111827" }}>i. Filing a Complaint</p>
            <ol>
              <li>Customers with a grievance can send it by email at {import.meta.env.VITE_COMPANY_EMAIL}.</li>
              <li>Customers may also send letters to the registered office of the Company at {registeredAddress()}.</li>
              <li>
                For proper resolution, customers are requested to mention the Loan Application
                Number or Loan Account Number while filing the complaint, along with the PAN
                Number.
              </li>
              <li>
                Anonymous complaints may be examined at the discretion of the Company, depending
                on the nature and seriousness of the issue raised.
              </li>
            </ol>

            <p style={{ fontWeight: 600, color: "#111827", marginTop: 16 }}>ii. Resolution Process</p>
            <ol>
              <li>
                <strong>Level 1 — Customer Care:</strong> The customer may lodge a complaint by
                calling {import.meta.env.VITE_COMPANY_PHONE} or emailing{" "}
                {import.meta.env.VITE_COMPANY_EMAIL}. The complaint is allotted to a Customer
                Service Executive, who sends an acknowledgement within 24 hours and works to
                resolve the complaint within 7 working days.
              </li>
              <li>
                <strong>Level 2 — Grievance Redressal Officer:</strong> If unsatisfied with the
                Level 1 resolution, the customer may escalate to the Grievance Redressal Officer,
                who provides a resolution within 7 working days of receipt.
              </li>
              <li>
                <strong>Level 3 — Nodal Officer:</strong> If unsatisfied with the Level 2
                resolution, the customer may escalate to the Nodal Officer, who provides a
                resolution within 15 working days of receipt.
              </li>
            </ol>

            <table className="grievance-table">
              <thead>
                <tr>
                  <th>Escalation</th>
                  <th>Contact</th>
                  <th>Next Step</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>First Escalation — Customer Care</td>
                  <td>
                    Phone: {import.meta.env.VITE_COMPANY_PHONE}
                    <br />
                    Email: {import.meta.env.VITE_COMPANY_EMAIL}
                  </td>
                  <td>If unresolved within 7 days, raise the issue with the Grievance Redressal Officer.</td>
                </tr>
                <tr>
                  <td>Second Escalation — Grievance Redressal Officer</td>
                  <td>
                    Email: {import.meta.env.VITE_BRAND_GRIEVANCE_OFFICER_EMAIL || `grievance@emisaathi.com`}
                    {import.meta.env.VITE_BRAND_GRIEVANCE_OFFICER_PHONE && (
                      <>
                        <br />
                        Phone: {import.meta.env.VITE_BRAND_GRIEVANCE_OFFICER_PHONE}
                      </>
                    )}
                  </td>
                  <td>If unresolved within 7 days, raise the issue with the Nodal Officer.</td>
                </tr>
                <tr>
                  <td>Third Escalation — Nodal Officer</td>
                  <td>
                    Email: {import.meta.env.VITE_BRAND_NODAL_OFFICER_EMAIL || `nodal@emisaathi.com`}
                    {import.meta.env.VITE_BRAND_NODAL_OFFICER_PHONE && (
                      <>
                        <br />
                        Phone: {import.meta.env.VITE_BRAND_NODAL_OFFICER_PHONE}
                      </>
                    )}
                  </td>
                  <td>The Nodal Officer ensures disposal of the complaint within 30 days from the date it was raised.</td>
                </tr>
              </tbody>
            </table>

            <p style={{ marginTop: 16 }}>
              The Company shall ensure that all complaints are resolved within 30 days from the
              date of raising the complaint by the customer.
            </p>
          </div>

          <div className="grievance-section">
            <h2 className="grievance-section-title">Review of the Policy</h2>
            <p>The Board shall review and amend this policy as and when required.</p>
            <p>
              If at any point a conflict of interpretation arises between this policy and any
              regulations, rules, guidelines, notifications, clarifications, circulars, or
              directions issued by relevant authorities ("Regulatory Provisions"), the
              interpretation of the Regulatory Provisions shall prevail.
            </p>
            <p>
              In case of any amendment(s) and/or clarification(s) to the Regulatory Provisions,
              this policy shall stand amended accordingly from the effective date specified as per
              the Regulatory Provisions.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GrievanceRedressal;
